import {
  Box,
  FormControl,
  FormControlLabel,
  InputLabel,
  Radio,
  RadioGroup,
  Select,
  Typography,
  useTheme,
} from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import Grid2 from "@mui/material/Grid2";
import TextInput from "../../components/Input/TextInput";
import CountrySelect from "../../components/SelectComponent/SelectCountry";
import { MuiPhoneComponent } from "../../components/Input/MuiPhoneComponent";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { Formik, Form, Field } from "formik";
import TextAreaComponent from "../../components/Input/TextAreaComponent";
import Checkbox from "@mui/material/Checkbox";
import DatePickerComponent from "../../components/SelectComponent/DatePicker";
import TimePickerComponent from "../../components/SelectComponent/TimePickerComponent";
import CheckboxListComponent from "../../components/SelectComponent/CheckBoxListComponent";
import RadioComponent from "../../components/SelectComponent/RadioComponent";
import NumberInputComponent from "../../components/Input/NumberInput";
import CardSection from "./CardSection";

const UserDetailsSection = ({
  defaultLanguage,
  values,
  errors,
  touched,
  setField,
  totalCount,
  languageWords,
  reservType,
  selectedDate,
  adult,
  child,
  kid,
  baby,
  toddler,
  selectedExtraProduct,
  time,
  transactionDetails,
  selectedCombination,
  transactionPrice,
  excludingVat,
  totalVat,
  totalIncludingVAT,
  totalCostYourBooking,
  GuestDetailsData,
  extraFieldsData,
  setAddFields,
  setGuestFields,
}) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const { WidgetSetting, key, widgetConfig, guestInfo } = useSelector(
    (store) => store?.widgetSettings
  );

  useEffect(() => {
    const guestFields = GuestDetailsData?.map((field) => ({
      idfield: field?.tag,
      data: values[
        field?.guestLanguages?.find((item) => item?.fieldname == "name")?.data
      ], // Get the corresponding form value or empty string
    }));
    const updatedFields = extraFieldsData?.map((field, i) => {
      //let fieldValue = values[field?.type === 'link' ? 'Link' :  field?.type == 'textarea' ? field?.fieldsLanguages[0]?.data?.replace(".", "") : field?.fieldsLanguages[0]?.data || ''] ;
      let fieldValue =
        values[
          field.fieldsLanguages.find((field) => field?.fieldname === "name")
            ?.data
        ];
      // Format time and date based on the field type
      if (field.type === "time" && fieldValue) {
        fieldValue = dayjs(fieldValue).format("HH:mm:ss"); // Format to hh:mm:ss
      }
      return {
        idfields: field?.idfields,
        name: field.fieldsLanguages.find((field) => field?.fieldname === "name")
          ?.data,
        data: fieldValue,
      };
    });
    dispatch(setAddFields(updatedFields));
    dispatch(setGuestFields(guestFields));
  }, [values]);

  return (
    <Form>
      <Box sx={{ mt: 5, p: 2 }}>
        <Grid2 container spacing={2}>
          <Grid2 size={{ md: 9, sm: 12, xs: 12 }}>
            <Box>
              <Typography
                variant="h6"
                sx={{
                  color: theme?.details?.formHeaderColor,
                  fontSize: "20px",
                  fontWeight: "bold",
                }}
              >
                {languageWords["ContactData"]}
              </Typography>
            </Box>
            <Box>
              {widgetConfig?.token ? (
                <Box sx={{ mt: 2 }}>
                  {guestInfo?.salutation && (
                    <Grid2 container>
                      <Grid2 size={{ xs: 6, md: 2 }}>
                        <Typography sx={{ mb: 1 }}>
                          <strong>
                            {languageWords?.Salutation || "Salutation"}
                          </strong>
                        </Typography>
                      </Grid2>
                      <Grid2 size={{ xs: 6, md: 2 }}>
                        <Typography sx={{ mb: 1 }}>
                          {guestInfo?.salutation}
                        </Typography>
                      </Grid2>
                    </Grid2>
                  )}
                  {guestInfo?.firstname && (
                    <Grid2 container>
                      <Grid2 size={{ xs: 6, md: 2 }}>
                        <Typography sx={{ mb: 1 }}>
                          <strong>
                            {languageWords?.firstname || "First Name"}
                          </strong>
                        </Typography>
                      </Grid2>
                      <Grid2 size={{ xs: 6, md: 2 }}>
                        <Typography sx={{ mb: 1 }}>
                          {guestInfo?.firstname}
                        </Typography>
                      </Grid2>
                    </Grid2>
                  )}
                  {guestInfo?.lastname && (
                    <Grid2 container>
                      <Grid2 size={{ xs: 6, md: 2 }}>
                        <Typography sx={{ mb: 1 }}>
                          <strong>
                            {languageWords?.lastname || "Last Name"}
                          </strong>
                        </Typography>
                      </Grid2>
                      <Grid2 size={{ md: 3 }}>
                        <Typography sx={{ mb: 1 }}>
                          {guestInfo?.lastname}
                        </Typography>
                      </Grid2>
                    </Grid2>
                  )}
                  {guestInfo?.email && (
                    <Grid2 container>
                      <Grid2 size={{ xs: 6, md: 2 }}>
                        <Typography sx={{ mb: 1 }}>
                          <strong>{languageWords?.email || "Email"}</strong>
                        </Typography>
                      </Grid2>
                      <Grid2 size={{ md: 3 }}>
                        <Typography sx={{ mb: 1 }}>
                          {guestInfo?.email}
                        </Typography>
                      </Grid2>
                    </Grid2>
                  )}
                  {guestInfo?.address && (
                    <Grid2 container>
                      <Grid2 size={{ xs: 6, md: 2 }}>
                        <Typography sx={{ mb: 1 }}>
                          <strong>{languageWords?.address || "Address"}</strong>
                        </Typography>
                      </Grid2>
                      <Grid2 size={{ md: 3 }}>
                        <Typography sx={{ mb: 1 }}>
                          {guestInfo?.address}
                        </Typography>
                      </Grid2>
                    </Grid2>
                  )}
                  {guestInfo?.country && (
                    <Grid2 container>
                      <Grid2 size={{ xs: 6, md: 2 }}>
                        <Typography sx={{ mb: 1 }}>
                          <strong>{languageWords?.country || "Country"}</strong>
                        </Typography>
                      </Grid2>
                      <Grid2 size={{ md: 3 }}>
                        <Typography sx={{ mb: 1 }}>
                          {guestInfo?.country}
                        </Typography>
                      </Grid2>
                    </Grid2>
                  )}
                  {guestInfo?.zipcode && (
                    <Grid2 container>
                      <Grid2 size={{ xs: 6, md: 2 }}>
                        <Typography sx={{ mb: 1 }}>
                          <strong>{languageWords?.zipcode || "Zipcode"}</strong>
                        </Typography>
                      </Grid2>
                      <Grid2 size={{ xs: 6, md: 2 }}>
                        <Typography sx={{ mb: 1 }}>
                          {guestInfo?.zipcode}
                        </Typography>
                      </Grid2>
                    </Grid2>
                  )}
                  {guestInfo?.phone && (
                    <Grid2 container>
                      <Grid2 size={{ xs: 6, md: 2 }}>
                        <Typography sx={{ mb: 1 }}>
                          <strong>{languageWords?.phone || "Phone"}</strong>
                        </Typography>
                      </Grid2>
                      <Grid2 size={{ md: 3 }}>
                        <Typography sx={{ mb: 1 }}>
                          {guestInfo?.phone}
                        </Typography>
                      </Grid2>
                    </Grid2>
                  )}
                  {guestInfo?.place && (
                    <Grid2 container>
                      <Grid2 size={{ xs: 6, md: 2 }}>
                        <Typography sx={{ mb: 1 }}>
                          <strong>{languageWords?.place || "Place"}</strong>
                        </Typography>
                      </Grid2>
                      <Grid2 size={{ md: 3 }}>
                        <Typography sx={{ mb: 1 }}>
                          {guestInfo?.place}
                        </Typography>
                      </Grid2>
                    </Grid2>
                  )}
                  {guestInfo?.otherfields && (
                    <Grid2 container>
                      <Grid2 size={{ xs: 6, md: 2 }}>
                        <Typography sx={{ mb: 1 }}>
                          <strong>
                            {languageWords?.otherfields || "Other fields"}
                          </strong>
                        </Typography>
                      </Grid2>
                      <Grid2 size={{ md: 3 }}>
                        <Typography sx={{ mb: 1 }}>
                          {guestInfo?.otherfields}
                        </Typography>
                      </Grid2>
                    </Grid2>
                  )}
                </Box>
              ) : (
                <Box>
                  {GuestDetailsData?.map((field, i) => {
                    switch (field?.tag) {
                      case "{salutation}":
                        return (
                          <Box sx={{ mt: 1 }}>
                            <InputLabel
                              sx={{
                                fontWeight: "bold",
                                fontSize: "15px",
                                color: theme?.details?.formLabelColor,
                              }}
                            >
                              {
                                field?.guestLanguages?.find(
                                  (item) => item?.fieldname == "name"
                                )?.data
                              }
                            </InputLabel>
                            <FormControl>
                              <RadioGroup
                                row
                                aria-labelledby="demo-row-radio-buttons-group-label"
                                name={
                                  field?.guestLanguages?.find(
                                    (item) => item?.fieldname == "name"
                                  )?.data
                                }
                                value={
                                  values[
                                    field?.guestLanguages?.find(
                                      (item) => item?.fieldname == "name"
                                    )?.data
                                  ]
                                }
                                onChange={(e) =>
                                  setField(
                                    field?.guestLanguages?.find(
                                      (item) => item?.fieldname == "name"
                                    )?.data,
                                    e.target.value
                                  )
                                }
                              >
                                {field?.guestLanguages[1]?.data
                                  ?.replace(/\\"/g, "") // Remove escaped double quotes
                                  ?.split("\n") // Split by newline characters
                                  ?.map((item) =>
                                    item.trim().replace(/^"|"$/g, "")
                                  ) // Remove leading/trailing quotes from each item
                                  ?.filter((item) => item !== "") // Filter out any empty strings
                                  ?.map((item) => (
                                    <FormControlLabel
                                      key={item} // Ensure each radio button has a unique key
                                      value={item}
                                      control={
                                        <Radio
                                          size="small"
                                          sx={{
                                            "&.Mui-checked": {
                                              color: theme?.palette?.themeColor, // Style when checked
                                            },
                                          }}
                                        />
                                      }
                                      label={
                                        <span
                                          style={{
                                            color: "#969BA0", // Conditional styling for label
                                            fontSize: "16px",
                                          }}
                                        >
                                          {item}
                                        </span>
                                      }
                                    />
                                  ))}
                              </RadioGroup>
                            </FormControl>
                          </Box>
                        );
                      case "{land}":
                        return (
                          <Box sx={{ mt: 2 }} key={i}>
                            <CountrySelect
                              style={{ width: "100%" }}
                              label={
                                field?.guestLanguages?.find(
                                  (item) => item?.fieldname == "name"
                                )?.data
                              }
                              name={
                                field?.guestLanguages?.find(
                                  (item) => item?.fieldname == "name"
                                )?.data
                              }
                              onChange={setField}
                              value={
                                values[
                                  field?.guestLanguages?.find(
                                    (item) => item?.fieldname == "name"
                                  )?.data
                                ]
                              }
                            />
                          </Box>
                        );

                      case "date":
                        return (
                          <Grid2 size={{ xs: 12, md: 6 }} key={i} mt={1}>
                            <DatePickerComponent
                              label={field?.info}
                              name={
                                field?.guestLanguages?.find(
                                  (item) => item?.fieldname == "name"
                                )?.data
                              }

                              // value={field?.guestLanguages?.find(item => item?.fieldname == 'name')?.data}
                            />
                          </Grid2>
                        );

                      case "{email}":
                        return (
                          <Grid2 size={{ xs: 12 }} key={i} mt={1}>
                            <TextInput
                              label={
                                field?.guestLanguages?.find(
                                  (item) => item?.fieldname == "name"
                                )?.data
                              }
                              name={
                                field?.guestLanguages?.find(
                                  (item) => item?.fieldname == "name"
                                )?.data
                              }
                              value={
                                values[
                                  field?.guestLanguages?.find(
                                    (item) => item?.fieldname == "name"
                                  )?.data
                                ]
                              }
                              // onChange={handleChange}
                              onChange={setField}
                              style={{ width: "100%" }}
                              error={
                                errors[
                                  field?.guestLanguages?.find(
                                    (item) => item?.fieldname == "name"
                                  )?.data
                                ]
                              } // Only show error when touched
                              helperText={
                                touched[
                                  field?.guestLanguages?.find(
                                    (item) => item?.fieldname == "name"
                                  )?.data
                                ] &&
                                errors[
                                  field?.guestLanguages?.find(
                                    (item) => item?.fieldname == "name"
                                  )?.data
                                ]
                              } // Show error message if field is touched and there is an error
                            />
                            {/* {errors[field?.guestLanguages?.find(item => item?.fieldname == 'name')?.data] && (
                          <FormHelperText
                            sx={{ color: "red", fontSize: "8px" }}
                          >{`${field?.guestLanguages?.find(item => item?.fieldname == 'name')?.data} is ${
                            errors[field?.guestLanguages?.find(item => item?.fieldname == 'name')?.data]
                          }!`}</FormHelperText>
                        )} */}
                          </Grid2>
                        );
                      case "{phone}":
                        return (
                          <Box sx={{ mt: 2 }} key={i}>
                            <MuiPhoneComponent
                              style={{ width: "100%" }}
                              label={
                                field?.guestLanguages?.find(
                                  (item) => item?.fieldname == "name"
                                )?.data
                              }
                              name={
                                field?.guestLanguages?.find(
                                  (item) => item?.fieldname == "name"
                                )?.data
                              }
                              value={
                                values[
                                  field?.guestLanguages?.find(
                                    (item) => item?.fieldname == "name"
                                  )?.data
                                ]
                              }
                              onChange={
                                setField // Update the value in Formik
                              }
                              error={
                                errors[
                                  field?.guestLanguages?.find(
                                    (item) => item?.fieldname == "name"
                                  )?.data
                                ]
                              } // Show error only if field is touched
                              helperText={
                                touched[
                                  field?.guestLanguages?.find(
                                    (item) => item?.fieldname == "name"
                                  )?.data
                                ] &&
                                errors[
                                  field?.guestLanguages?.find(
                                    (item) => item?.fieldname == "name"
                                  )?.data
                                ]
                              } // Show helperText on error
                            />
                            {/* {errors[field?.guestLanguages?.find(item => item?.fieldname == 'name')?.data] && (
                          <FormHelperText sx={{ color: "red", fontSize: "8px" }}>
                            {`${field?.guestLanguages?.find(item => item?.fieldname == 'name')?.data} is ${
                              errors[field?.guestLanguages?.find(item => item?.fieldname == 'name')?.data]
                            }!`}
                          </FormHelperText>
                        )} */}
                          </Box>
                        );
                      default:
                        return (
                          <Grid2 size={{ xs: 12 }} key={i} mt={1}>
                            <TextInput
                              label={
                                field?.guestLanguages?.find(
                                  (item) => item?.fieldname == "name"
                                )?.data
                              }
                              name={
                                field?.guestLanguages?.find(
                                  (item) => item?.fieldname == "name"
                                )?.data
                              }
                              value={
                                values[
                                  field?.guestLanguages?.find(
                                    (item) => item?.fieldname == "name"
                                  )?.data
                                ]
                              }
                              onChange={setField}
                              error={
                                errors[
                                  field?.guestLanguages?.find(
                                    (item) => item?.fieldname == "name"
                                  )?.data
                                ]
                              } // Only show error when touched
                              helperText={
                                touched[
                                  field?.guestLanguages?.find(
                                    (item) => item?.fieldname == "name"
                                  )?.data
                                ] &&
                                errors[
                                  field?.guestLanguages?.find(
                                    (item) => item?.fieldname == "name"
                                  )?.data
                                ]
                              } // Show error message if field is touched and there is an error
                            />
                          </Grid2>
                        );
                    }
                  })}
                </Box>
              )}
            </Box>
            {extraFieldsData?.length > 0 && (
              <Box>
                <Typography
                  variant="h6"
                  sx={{
                    color: theme?.details?.formHeaderColor,
                    fontSize: "20px",
                    fontWeight: "bold",
                    mt: 2,
                    mb: 2,
                  }}
                >
                  {languageWords["ExtraInformation"]}
                </Typography>

                {extraFieldsData?.map((field, i) => {
                  switch (field?.type) {
                    case "textarea":
                      return (
                        <Grid2 size={{ xs: 12, md: 12 }} key={i}>
                          <TextAreaComponent
                            label={
                              field &&
                              field.fieldsLanguages &&
                              field.fieldsLanguages.find(
                                (field) => field?.fieldname === "info"
                              )?.data
                            }
                            name={field.fieldsLanguages
                              .find((field) => field?.fieldname === "name")
                              ?.data?.replace(".", "")}
                            setField={setField}
                            value={
                              values[
                                field.fieldsLanguages.find(
                                  (field) => field?.fieldname === "name"
                                )?.data
                              ]
                            }
                            error={
                              errors[
                                field.fieldsLanguages.find(
                                  (field) => field?.fieldname === "name"
                                )?.data
                              ]
                            }
                          />
                        </Grid2>
                      );
                    case "number":
                      return (
                        <Grid2 size={{ xs: 12, md: 5, sm: 12 }} key={i}>
                          <NumberInputComponent
                            label={
                              field?.fieldsLanguages?.find(
                                (item) =>
                                  item?.fieldname == "info" && item?.data
                              )?.data
                            }
                            name={
                              field?.fieldsLanguages?.find(
                                (item) =>
                                  item?.fieldname == "name" && item?.data
                              )?.data
                            }
                            setField={setField}
                            value={
                              values[
                                field?.fieldsLanguages?.find(
                                  (item) =>
                                    item?.fieldname == "name" && item?.data
                                )?.data
                              ] || 0
                            } // Default value to 0 if undefined
                            error={
                              errors[
                                field.fieldsLanguages.find(
                                  (field) => field?.fieldname === "name"
                                )?.data
                              ]
                            }
                          />
                        </Grid2>
                      );

                    case "date":
                      return (
                        <Grid2 size={{ xs: 12, md: 3 }} key={i} mt={1}>
                          <DatePickerComponent
                            label={
                              field?.fieldsLanguages?.find(
                                (item) =>
                                  item?.fieldname == "name" && item?.data
                              )?.data
                            }
                            name={
                              field?.fieldsLanguages?.find(
                                (item) =>
                                  item?.fieldname == "name" && item?.data
                              )?.data
                            }
                            value={
                              values[
                                field?.fieldsLanguages?.find(
                                  (item) =>
                                    item?.fieldname == "name" && item?.data
                                )?.data
                              ]
                            }
                            onChange={setField}
                            lang={defaultLanguage}
                            error={
                              errors[
                                field?.fieldsLanguages?.find(
                                  (item) =>
                                    item?.fieldname == "name" && item?.data
                                )?.data
                              ]
                            }
                            // value={field?.guestLanguages?.find(item => item?.fieldname == 'name')?.data}
                          />
                        </Grid2>
                      );
                    case "time":
                      return (
                        <Grid2 size={{ xs: 12, md: 3 }}>
                          <TimePickerComponent
                            label={
                              field?.fieldsLanguages?.find(
                                (item) =>
                                  item?.fieldname == "name" && item?.data
                              )?.data
                            }
                            name={
                              field?.fieldsLanguages?.find(
                                (item) =>
                                  item?.fieldname == "name" && item?.data
                              )?.data
                            }
                            value={
                              values[
                                field?.fieldsLanguages?.find(
                                  (item) =>
                                    item?.fieldname == "name" && item?.data
                                )?.data
                              ]
                            }
                            onChange={setField}
                            // value={field?.guestLanguages?.find(item => item?.fieldname == 'name')?.data}
                          />
                        </Grid2>
                      );
                    case "tel":
                      return (
                        <Grid2 size={{ xs: 12, md: 5, mt: 2, mb: 2 }}>
                          <MuiPhoneComponent
                            style={{ width: "100%" }}
                            label={
                              field?.fieldsLanguages?.find(
                                (item) =>
                                  item?.fieldname == "name" && item?.data
                              )?.data
                            }
                            name={
                              field?.fieldsLanguages?.find(
                                (item) =>
                                  item?.fieldname == "name" && item?.data
                              )?.data
                            }
                            value={
                              values[
                                field?.fieldsLanguages?.find(
                                  (item) =>
                                    item?.fieldname == "name" && item?.data
                                )?.data
                              ]
                            }
                            onChange={
                              setField // Update the value in Formik
                            }
                            helperText={
                              touched[
                                field?.fieldsLanguages?.find(
                                  (item) =>
                                    item?.fieldname == "name" && item?.data
                                )?.data
                              ] &&
                              errors[
                                field?.fieldsLanguages?.find(
                                  (item) =>
                                    item?.fieldname == "name" && item?.data
                                )?.data
                              ]
                            } // Show helperText on error
                            error={
                              errors[
                                field?.fieldsLanguages?.find(
                                  (item) =>
                                    item?.fieldname == "name" && item?.data
                                )?.data
                              ]
                            }
                          />
                        </Grid2>
                      );
                    case "radio":
                      return (
                        <RadioComponent
                          field={field}
                          setField={setField}
                          error={
                            errors[
                              field?.fieldsLanguages?.find(
                                (item) =>
                                  item?.fieldname == "name" && item?.data
                              )?.data
                            ]
                          }
                        />
                      );
                    case "select":
                      return (
                        <Grid2 size={{ md: 5, sm: 12 }} sx={{ mt: 2 }} key={i}>
                          {field?.fieldsLanguages?.find(
                            (item) => item?.fieldname == "name" && item?.data
                          )?.data && (
                            <InputLabel
                              sx={{
                                fontWeight: "bold",
                                fontSize: "15px",
                                color: theme?.details?.formLabelColor,
                                mb: 1,
                              }}
                            >
                              {
                                field?.fieldsLanguages?.find(
                                  (item) =>
                                    item?.fieldname == "info" && item?.data
                                )?.data
                              }
                            </InputLabel>
                          )}

                          <FormControl
                            sx={{
                              width: "100%",
                              "& fieldset": {
                                borderColor: errors[
                                  field?.fieldsLanguages?.find(
                                    (item) =>
                                      item?.fieldname == "name" && item?.data
                                  )?.data
                                ]
                                  ? "red"
                                  : "#EBEBEB",
                              },
                              "&:hover fieldset": {
                                borderColor: errors[
                                  field?.fieldsLanguages?.find(
                                    (item) =>
                                      item?.fieldname == "name" && item?.data
                                  )?.data
                                ]
                                  ? "red"
                                  : "#EBEBEB",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: errors[
                                  field?.fieldsLanguages?.find(
                                    (item) =>
                                      item?.fieldname == "name" && item?.data
                                  )?.data
                                ]
                                  ? "red"
                                  : "#0B5753",
                              },
                            }}
                          >
                            <Select
                              native
                              name={
                                field?.fieldsLanguages?.find(
                                  (item) =>
                                    item?.fieldname == "name" && item?.data
                                )?.data
                              }
                              value={field?.fieldsLanguages
                                ?.find(
                                  (item) =>
                                    item?.fieldname == "info" && item?.data
                                )
                                ?.data?.split("\n")
                                .find((item) => item.includes("[C]"))}
                              onChange={(e) =>
                                setField(
                                  field?.fieldsLanguages?.find(
                                    (item) =>
                                      item?.fieldname == "name" && item?.data
                                  )?.data,
                                  e.target.value
                                )
                              }
                              // Removed label prop to avoid the outlined border label
                            >
                              {field?.fieldsLanguages[2]?.data
                                ?.split("\n")
                                ?.map((item) => (
                                  <option value={item} key={item}>
                                    {item?.replace("[C]", " ")}
                                  </option>
                                ))}
                            </Select>
                          </FormControl>
                        </Grid2>
                      );
                    case "termsandcondition":
                      return (
                        <Box sx={{ mt: 2 }} key={i}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                size="small"
                                checked={
                                  values[
                                    field?.fieldsLanguages?.find(
                                      (item) =>
                                        item?.fieldname == "info" &&
                                        item?.data.trim() != ""
                                    )?.data
                                  ]
                                }
                                onChange={(e) =>
                                  setField(
                                    field?.fieldsLanguages?.find(
                                      (item) =>
                                        item?.fieldname == "name" &&
                                        item?.data.trim() != ""
                                    )?.data,
                                    e.target.checked
                                  )
                                }
                                sx={{
                                  color: "red", // Unchecked color
                                  "&.Mui-checked": {
                                    color: theme?.details?.formCheckBoxColor, // Checked color
                                  },
                                }}
                              />
                            }
                            label={
                              <a
                                style={{
                                  color: theme?.details?.formLinkColor,
                                  "&:hover": {
                                    color: theme?.details?.formLinkColorHover,
                                  },
                                }}
                                target="_blank"
                                rel="noopener noreferrer"
                                href={field?.options}
                              >
                                {
                                  field?.fieldsLanguages?.find(
                                    (item) => item?.fieldname == "info"
                                  )?.data
                                }
                              </a>
                            }
                          />
                        </Box>
                      );
                    case "checkbox":
                      return (
                        <Box sx={{ mt: 2 }} key={i}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                size="small"
                                name={
                                  field?.fieldsLanguages?.find(
                                    (item) =>
                                      item?.fieldname == "name" && item?.data
                                  )?.data
                                }
                                checked={
                                  values[
                                    field?.fieldsLanguages?.find(
                                      (item) =>
                                        item?.fieldname == "name" && item?.data
                                    )?.data
                                  ]
                                }
                                onChange={(e) =>
                                  setField(
                                    field?.fieldsLanguages?.find(
                                      (item) =>
                                        item?.fieldname == "name" && item?.data
                                    )?.data,
                                    e.target.checked
                                  )
                                }
                                sx={{
                                  color: errors[
                                    field?.fieldsLanguages?.find(
                                      (item) =>
                                        item?.fieldname == "name" && item?.data
                                    )?.data
                                  ]
                                    ? "red"
                                    : "gray", // Unchecked color
                                  "&.Mui-checked": {
                                    color: theme?.details?.formCheckBoxColor, // Checked color
                                  },
                                }}
                              />
                            }
                            label={
                              field?.fieldsLanguages?.find(
                                (item) =>
                                  item?.fieldname == "info" && item?.data
                              )?.data
                            }
                          />
                        </Box>
                      );
                    case "file":
                    case "checkboxList":
                      return (
                        <CheckboxListComponent
                          field={field}
                          setField={setField}
                          style={{
                            "&.Mui-checked": {
                              color: theme?.details?.formCheckBoxColor, // Checked color
                            },
                          }}
                        />
                      );
                    case "link":
                      return (
                        <Box sx={{ mt: 2 }}>
                          <a
                            href={field?.fieldsLanguages[0]?.data}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              color: theme?.details?.formLinkColor,
                              "&:hover": {
                                color: theme?.details?.formLinkColorHover,
                              },
                              fontSize: "15px",
                              fontWeight: "bold",
                              mt: 2,
                            }}
                          >
                            {
                              field?.fieldsLanguages?.find(
                                (item) => item?.fieldname == "options"
                              )?.data
                            }
                          </a>
                        </Box>
                      );
                    case "label":
                      return (
                        <Box sx={{ mt: 2 }}>
                          <InputLabel sx={{ mb: 1 }}>
                            {" "}
                            {
                              field?.fieldsLanguages?.find(
                                (item) => item?.fieldname == "info"
                              )?.data
                            }
                          </InputLabel>

                          <Typography>
                            {
                              field?.fieldsLanguages?.find(
                                (item) => item?.fieldname == "info"
                              )?.data
                            }
                          </Typography>
                        </Box>
                      );

                    default:
                      return (
                        <Grid2 size={{ xs: 12, md: 12 }} key={i} mt={1}>
                          <TextInput
                            label={
                              field?.fieldsLanguages?.find(
                                (item) =>
                                  item?.fieldname == "name" && item?.data
                              )?.data
                            }
                            name={
                              field?.fieldsLanguages?.find(
                                (item) =>
                                  item?.fieldname == "name" && item?.data
                              )?.data
                            }
                            value={
                              values[
                                field?.fieldsLanguages?.find(
                                  (item) =>
                                    item?.fieldname == "name" && item?.data
                                )?.data
                              ]
                            }
                            placeholder={
                              field?.fieldsLanguages?.find(
                                (item) =>
                                  item?.fieldname == "info" && item?.data
                              )?.data
                            }
                            onChange={setField}
                            error={
                              errors[
                                field?.fieldsLanguages?.find(
                                  (item) =>
                                    item?.fieldname == "name" && item?.data
                                )?.data
                              ]
                            } // Only show error when touched
                            helperText={
                              touched[
                                field?.fieldsLanguages?.find(
                                  (item) =>
                                    item?.fieldname == "info" && item?.data
                                )?.data
                              ] &&
                              errors[
                                field?.fieldsLanguages?.find(
                                  (item) =>
                                    item?.fieldname == "info" && item?.data
                                )?.data
                              ]
                            } // Show error message if field is touched and there is an error
                            typeLabel={field?.type == "label" ? true : false}
                          />
                        </Grid2>
                      );
                  }
                })}
              </Box>
            )}
          </Grid2>

          <Grid2 size={{ md: 3, sm: 12, xs: 12 }}>
            <CardSection
              totalCount={totalCount}
              languageWords={languageWords}
              reservType={reservType}
              selectedDate={selectedDate}
              adult={adult}
              child={child}
              kid={kid}
              baby={baby}
              toddler={toddler}
              selectedExtraProduct={selectedExtraProduct}
              time={time}
              transactionDetails={transactionDetails}
              selectedCombination={selectedCombination}
              transactionPrice={transactionPrice}
              excludingVat={excludingVat}
              totalVat={totalVat}
              totalIncludingVAT={totalIncludingVAT}
              totalCostYourBooking={totalCostYourBooking}
            />
          </Grid2>
        </Grid2>

        {/* Submit button is handled on the parent stepper */}
      </Box>
    </Form>
  );
};

export default UserDetailsSection;
